import { PREVIEW_ENABLED } from './preview-enabled';

/** `/preview` and everything under it. */
export function isPreviewPath(pathname: string): boolean {
  return /^\/preview(\/|$)/.test(pathname);
}

/**
 * A document opened on `/preview` is a preview session for its whole life:
 * demo data, no sign-in, no network, no telemetry. `core/env.ts` reads this
 * once at load and forces `PLATFORM_MODE` off, so a preview never reaches the
 * API, even on a platform build.
 */
export function isPreviewSession(
  pathname: string = typeof window === 'undefined' ? '' : window.location.pathname,
  enabled: boolean = PREVIEW_ENABLED,
): boolean {
  return enabled && isPreviewPath(pathname);
}
